import { GuaranteeCommissionFormData } from './GuaranteeCommissionFormData';

export const guaranteeCommissionValidation = (formData: GuaranteeCommissionFormData) => {
  const selectedLand = formData.lands.find(l => l.landCode === formData.selectedLandCode)!;
  return !selectedLand.error;
};